import { alpha } from '@mui/material/styles';
import { listClasses } from '@mui/material/List';
import { paperClasses } from '@mui/material/Paper';
import { buttonClasses } from '@mui/material/Button';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { paper } from '../../css';
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const isLight = theme.palette.mode === 'light';
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    borderWidth: 0,
                    '& .MuiDataGrid-cell': {
                        border: 'none !important',
                        color: isLight ? theme.palette.text.primary : theme.palette.text.secondary
                    },
                    '& .MuiSvgIcon-root ': {
                        color: isLight ? 'rgba(69, 79, 91, 1)' : theme.palette.common.white
                    },
                    '& .MuiDataGrid-row': {
                        cursor: 'pointer',
                        border: 'none !important',
                        borderRight: '0 !important',
                        '&:nth-of-type(odd)': {
                            backgroundColor: isLight ? theme.palette.common.white : theme.palette.background.paper
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: isLight
                                ? theme.palette.action.hover
                                : alpha(theme.palette.grey[600], 0.08)
                        },
                        '&:hover': {
                            backgroundColor: isLight
                                ? alpha(theme.palette.primary.main, 0.1)
                                : alpha(theme.palette.primary.light, 0.1),
                            cursor: 'pointer'
                        }
                    },
                    '.MuiDataGrid-columnHeader': {
                        background: 'transparent'
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none'
                    },
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none'
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        fontWeight: '600 !important',
                        overflow: 'visible !important',
                        color: isLight ? theme.palette.text.secondary : theme.palette.text.secondary
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: 'auto'
                    },
                    '& .MuiDataGrid-row.Mui-selected': {
                        backgroundColor: isLight
                            ? alpha(theme.palette.primary.main, 0.2)
                            : alpha(theme.palette.primary.dark, 0.3)
                    },
                    '& .MuiDataGrid-withBorderColor': {
                        borderColor: 'transparent'
                    },
                    '--DataGrid-rowBorderColor': 'transparent',
                    '--DataGrid-containerBackground': 'transparent',
                    '.MuiDataGrid-virtualScrollerContent': {
                        marginTop: 8,
                        borderRadius: 8,
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        '.MuiDataGrid-virtualScrollerRenderZone': {
                            overflow: 'hidden',
                            borderRadius: 8
                        }
                    }
                },
                cell: {
                    borderBottom: '1px dashed transparent'
                },
                selectedRowCount: {
                    whiteSpace: 'nowrap'
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: 'none'
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                    backgroundColor: isLight
                        ? theme.palette.background.neutral
                        : alpha(theme.palette.grey[500], 0.12)
                },
                paper: {
                    ...paperStyles,
                    padding: 0
                },
                menu: {
                    [`& .${paperClasses.root}`]: {
                        ...paperStyles
                    },
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2)
                        }
                    }
                },
                columnHeaders: {
                    height: 'auto',
                    minHeight: 56,
                    borderRadius: 8,
                    backgroundColor: isLight
                        ? theme.palette.background.neutral
                        : theme.palette.grey[700]
                },
                panelHeader: {
                    padding: theme.spacing(2)
                },
                footerContainer: {
                    marginTop: 8,
                    borderRadius: 8,
                    background: theme.palette.background.neutral
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: 'flex-end',
                    borderTop: `dashed 1px ${theme.palette.divider}`,
                    [`& .${buttonClasses.root}`]: {
                        '&:last-of-type': {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary
                        }
                    }
                },
                filterForm: {
                    padding: theme.spacing(2)
                },
                filterFormValueInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2)
                }
            }
        }
    };
}
